<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const isNavFixed = computed(() => store.state.isNavFixed);

const darkMode = computed(() => store.state.darkMode);

const { t } = useI18n();

let pages = [];

pages['Cartões de crédito'] = t('message.menu.credit_card', 2);
pages['Visão Geral'] = t('message.menu.home');
pages['Transações'] = t('message.global.transaction', 1);
pages['Fatura'] = t('message.global.invoice');
pages['Categorias'] = t('message.menu.category', 2);
pages['Contas'] = t('message.global.bank_account', 2);
pages['Minha Conta'] = t('message.menu.my_account');
pages['Suporte'] = t('message.menu.support');
pages['Objetivos'] = t('message.global.objetive', 1);
pages['Integrações'] = t('message.menu.integration', 1);
pages['Clientes'] = t('message.menu.customer', 1);

const get_page = (p) => {

  if(pages[p]){
    return pages[p];
  }
  else{
    return p;
  }

}

defineProps({
  currentPage: {
    type: String,
    default: "",
  },
  currentDirectory: {
    type: String,
    default: "",
  },
});
</script>
<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      v-bind:class="{
          'me-sm-6': !isRTL,
          'text-dark': isNavFixed,
          'fc-azul-petroleo': !darkMode,
          'text-white': darkMode
      }"
    >
      <li class="text-sm breadcrumb-item">
        
        <a
          v-bind:class="{
          'text-dark': isNavFixed,
          'fc-azul-petroleo': !darkMode,
          'text-white': darkMode
      }"
          class="opacity-8"
          href="#"
          >Contive</a
        >
      </li>
      <li
        class="text-sm breadcrumb-item active"
        v-bind:class="{
          'text-dark': isNavFixed,
          'fc-azul-petroleo': !darkMode,
          'text-white': darkMode
      }"
        aria-current="page"
      >
        {{ get_page(currentPage) }}
      </li>
    </ol>
    
  </nav>
</template>
